<!-- 页面右侧卡片组件封装 -->
<template>
  <el-card class="box" :style="{height: height + 'px'}">
    <div slot="header" class="clearfix">
      <slot name="title" />
      <slot name="btn" />
    </div>
    <slot name="content" />
  </el-card>
</template>
<script lang="js">
export default {
  data() {
    return {
      height: 0
    }
  },
  created() {
    this.height = document.documentElement.clientHeight - 77;
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  display: flex;
  flex-direction: column;
  /deep/.el-card__body {
    flex: 1;
  }
}
</style>